<template>
  <div class="top-fieldset" :class="blockClasses">
    <div class="top-fieldset__fields" :class="elementClasses('fields')">
      <div :class="[...elementClasses('field'), ...elementClasses('field_' + field.key)]" v-for="field in fields">
        <Field v-if="field.visible" :fieldKey="field.key" :filterKey="filterKey"/>
      </div>

<!--      <a href="javascript:void(0);" class="top-fieldset__pair-button button button_pair button_link-button button__dashed-text-wrap">-->
<!--          <span class="button__icon">-->
<!--            <LoupePlus/>-->
<!--          </span>-->

<!--        <span class="button__dashed-text texts texts_body">-->
<!--            Поиск спарки-->
<!--          </span>-->
<!--      </a>-->

      <div class="top-fieldset__buttons-wrap top-fieldset__buttons-wrap_mobile">
        <button class="top-fieldset__button top-fieldset__button_mobile button button__default button_red"
                :class="elementClasses('button')"
                data-filter-submit
                :data-filter-key="filterKey"
                :disabled="isDisabled"
        >
          <span class="button__text text__button">
              Подобрать
          </span>
        </button>
      </div>

      <div class="top-fieldset__total-wrap">
        <div class="top-fieldset__total">
          <div class="top-fieldset__total-count-wrap" v-show="this.showTotal()">
            <div class="top-fieldset__total-title texts texts_body">
              Найдено:&nbsp;
            </div>

            <div class="top-fieldset__count texts texts_body">
              {{ this.total }} товаров
            </div>
          </div>
        </div>
        <div class="top-fieldset__buttons-wrap" :class="elementClasses('buttons-wrap')">
          <a href="javascript:void(0)"
             class="top-fieldset__reset-button button button__reset-filter"
             @click="this.clear()"
          >
            <span class="button__icon">
                <ResetFilter/>
            </span>
            <span class="button__reset-filter-text button__reset-filter-text_desk">
                Сбросить фильтр
            </span>
            <span class="button__reset-filter-text button__reset-filter-text_mob">
                Очистить
            </span>
          </a>
          <button class="top-fieldset__button button button__ellipse button_yellow"
                  :class="elementClasses('button')"
                  data-filter-submit
                  :data-filter-key="filterKey"
                  :disabled="isDisabled"
          >
            <span class="top-fieldset__button-text texts texts_button">
                  Подобрать
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {fieldsetMixin} from "./fieldsetMixin";
  import Field from "../field/Field.vue";
  import Question from "../../components/icons/Question";
  import { FilterManagerPool } from "../manager";
  import LoupePlus from "../../components/icons/LoupePlus.vue";
  import ResetFilter from "../../components/icons/ResetFilter.vue";

  export default {
    name: "TopFieldset",
    components: {ResetFilter, LoupePlus, Question, Field},
    mixins: [
      fieldsetMixin
    ],
    computed: {
      isDisabled() {
        if (this.fields) {
          return this.fields.some((field) => Boolean(this.values[field.key]) === false);
        }
        return false;
      },
      manufacturer() {
        return this.values ? this.values.manufacturer : null;
      },
      model() {
        return this.values ? this.values.model : null;
      },
      generation() {
        return this.values ? this.values.generation : null;
      },
      modification() {
        return this.values ? this.values.modification : null;
      },
      total() {
        return this.filterAttributes ? this.filterAttributes.total : null
      },
      currentUrl() {
        return window.location.href;
      },
    },
    watch: {
      manufacturer: {
        handler(value) {
          if (value !== undefined && value !== 0) {
            this.manager.filterStore.isLoading.model = true;

            if (this.model !== 0) {
              this.manager.filterStore.isLoading.generation = true;
              this.manager.filterStore.isLoading.modification = true;

              this.filtersValues[this.filterKey].model.value = 0;
              if (this.generation !== 0) {
                this.filtersValues[this.filterKey].generation.value = 0;
              }
              if (this.modification !== 0) {
                this.filtersValues[this.filterKey].modification.value = 0;
              }
            }

            this.manager.submit().then(() => {
              this.manager.filterStore.isLoading.model = false;
              this.manager.filterStore.isLoading.generation = false;
              this.manager.filterStore.isLoading.modification = false;
            });
          }

        }
      },
      model: {
        handler(value) {
          if (value !== undefined && value !== 0) {
            this.manager.filterStore.isLoading.generation = true;

            if (this.generation !== 0) {
              this.manager.filterStore.isLoading.modification = true;

              this.filtersValues[this.filterKey].generation.value = 0;
              if (this.modification !== 0) {
                this.filtersValues[this.filterKey].modification.value = 0;
              }
            }

            this.manager.submit().then(() => {
              this.manager.filterStore.isLoading.generation = false;
              this.manager.filterStore.isLoading.modification = false;
            });
          }
        }
      },
      generation: {
        handler(value) {
          if (value !== undefined && value !== 0) {
            this.manager.filterStore.isLoading.modification = true;

            if (this.modification !== 0) {
              this.filtersValues[this.filterKey].modification.value = 0;
            }

            this.manager.submit().then(() => {
              this.manager.filterStore.isLoading.modification = false;
            });
          }
        }
      },
    },
    methods: {
      clear() {
        this.manager.submit(null, true);
      },
      showTotal() {
        return this.filterKey !== 'CarTyreFilter';
      }
    },
    mounted() {
      this.manager = FilterManagerPool.getManager(this.filterKey);
    }
  }
</script>

<style lang="scss">

</style>